export enum DashboardRoutes {
  DASHBOARD = '/dashboard',
  WELCOME = '/boas-vindas',
  SETUP = '/configuracoes-empresa',
  BANNER = '/banner',
  HR_AREA_PRESENTATION = '/area-rh',
}
